module.exports = __webpack_public_path__ + "static/media/planet-space-world.8c317a3a.png";